import { styled } from '@mui/material';

export const Thumb = styled('div')`
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  position: relative;

  &:hover {
    .remove-btn {
      display: flex;
    }
  }
`;

export const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MoreImages = styled('div')`
  position: absolute;
  bottom: -20px;
  right: -32px;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.main};
`;
